<template>
	<el-popover placement="top" v-model="visible" trigger="click">
		<div>
			<Picker v-show="true" set="apple" :i18n="i18n" :showPreview="false" :showSearch="false" :showCategories="false" @select="handleEmojiSelect" />
		</div>
		<el-button slot="reference" type="default" size="mini" icon="fa fa-smile-o" />
	</el-popover>
</template>

<script>
import { Picker, Emoji } from "emoji-mart-vue";

export default {
	components: {
		Picker,
		Emoji,
	},

	name: "ChatEmojiPicker",

	props: [],

	mounted() {},

	data() {
		return {
			visible: false,

			i18n: {
				categories: {
					recent: this.$t("chatEmojiPicker.recent"),
					people: this.$t("chatEmojiPicker.people"),
					nature: this.$t("chatEmojiPicker.nature"),
					foods: this.$t("chatEmojiPicker.foods"),
					activity: this.$t("chatEmojiPicker.activity"),
					places: this.$t("chatEmojiPicker.places"),
					objects: this.$t("chatEmojiPicker.objects"),
					symbols: this.$t("chatEmojiPicker.symbols"),
					flags: this.$t("chatEmojiPicker.flags"),
				},
			},
		};
	},

	methods: {
		handleEmojiSelect(event) {
			this.$emit("select", event);
			this.visible = false;
		},
	},
};
</script>

<style lang="less" scoped>
.emoji-mart-category-label {
	font-size: 12px;
}
</style>
